module.exports = __webpack_public_path__ + "img/lms_logo.0a92ef0d.png";